import React, { ReactNode } from 'react';
import { FacebookDetailedIcon } from '@fiverr-private/icons';

import { SocialButton } from '../SocialButton';
import { translate } from '../../utils/translate';
import { SocialProvider } from '../SocialButton/constants';
import { AuthenticationResponse } from '../../shared/constants/authenticationFlow';

interface FacebookButtonProps {
    children?: ReactNode;
    onSuccess?: (provider: SocialProvider, authenticationResponse: AuthenticationResponse) => void;
    onError?: (provider: SocialProvider, authenticationResponse: AuthenticationResponse) => void;
    onClick?: () => void;
}

export const FacebookButton = ({
    children = translate('social_buttons.continue_with_facebook'),
    onSuccess,
    onError,
    onClick,
}: FacebookButtonProps) => (
    <SocialButton
        SocialIcon={FacebookDetailedIcon}
        provider="facebook"
        onSuccess={onSuccess}
        onError={onError}
        onClick={onClick}
    >
        {children}
    </SocialButton>
);
